const profileInfoStyles = (theme) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
    avatar: {
      width: 90,
      height: 90,
      fontSize: 32,
      fontWeight: 600,
      background: "linear-gradient(135deg, #1E90FF, #007BFF)",
      color: "#fff",
      mb: 2,
    },
    username: {
      fontSize: "22px",
      fontWeight: 700,
      color: theme.palette.mode === "dark" ? "#fff" : "#333",
      mb: 0.5,
    },
    email: {
      fontSize: "14px",
      color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.6)",
      mb: 3,
    },
  });
  
  export default profileInfoStyles;
  